import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/* items: [{ label, to }] — the last item is rendered as the current (non-link) page.
   Emits BreadcrumbList JSON-LD for SEO (added Feb 2026). */
export default function Breadcrumbs({ items = [], className = "", includeHome = true }) {
  if (!items.length) return null;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const chain = includeHome ? [{ label: "Home", to: "/" }, ...items] : items;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: chain.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.label,
      ...(c.to ? { item: origin + c.to } : {}),
    })),
  };
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`flex flex-wrap items-center gap-1 text-sm ${className}`}>
      {includeHome && (
        <Link to="/" className="inline-flex items-center text-current/70 hover:text-current opacity-80 hover:opacity-100" data-testid="crumb-home"><Home className="w-4 h-4" /></Link>
      )}
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="inline-flex items-center gap-1">
            {(includeHome || i > 0) && <ChevronRight className="w-4 h-4 opacity-50" />}
            {last || !it.to ? (
              <span className="font-600" data-testid={`crumb-current`}>{it.label}</span>
            ) : (
              <Link to={it.to} className="opacity-80 hover:opacity-100 hover:underline underline-offset-2" data-testid={`crumb-${i}`}>{it.label}</Link>
            )}
          </span>
        );
      })}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </nav>
  );
}
